var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { hasNewInfosetKanban } from '@/shared/utils/helpers';
import InfosetReborn from '@/pages/InfosetReborn.vue';
import InfosetLegacy from '@/pages/InfosetLegacy.vue';
import { mixpanelTracking } from '@/services/mixpanel';
let Infoset = class Infoset extends Vue {
    /**
     * Usuário da sessão: currentUser (overmind) é a fonte primária; o fallback
     * cobre o primeiro render antes de o estado hidratar (vue-auth mantém o user
     * em cache). Mesma leitura de `pages/Infosets.vue`.
     */
    get sessionUser() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        return stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
    }
    /** Só contas com a flag veem a campanha nova. */
    get hasNewKanban() {
        return hasNewInfosetKanban(this.sessionUser);
    }
    // Mesmo evento que `Infoset.container.vue` (a implementação antiga) dispara
    // no seu próprio `mounted` — ele só roda quando `InfosetLegacy` é quem
    // renderiza, então o switcher dispara aqui para continuar valendo nos dois
    // casos.
    mounted() {
        mixpanelTracking('pre-crm: Acessou o pré-CRM');
    }
};
Infoset = __decorate([
    Component(connect(({ state }) => ({
        currentUser: state.users.currentUser,
    }), {
        name: 'Infoset',
        components: { InfosetReborn, InfosetLegacy },
    }))
], Infoset);
export default Infoset;
